import PropTypes from "prop-types";

import Grid2 from "@mui/material/Grid2";
import Box from "@mui/material/Box";
import ListItemText from "@mui/material/ListItemText";

import SelectListButton from "@/components/SelectListButton";

const FontList = ({ items = [], selected, onChange, page = 0 }) => {
  const pageCount = items.length || 1;

  return (
    <Box
      width="100%"
      className="pb-4"
      sx={{
        overflowX: "hidden",
        overflowY: "visible",
        width: "100%",
        maxWidth: "100%",
        position: "relative",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",
          width: `${pageCount * 100}%`,
          transition: "transform 0.35s ease",
          transform: `translateX(-${(page * 100) / pageCount}%)`,
        }}
      >
        {items.map((list, i) => (
          <Box
            key={i}
            sx={{
              flex: "1 1 0",
              minWidth: 0,
              boxSizing: "border-box",
              pt: "5px",
              pr: "5px",
              pb: "5px",
              pl: "2px",
            }}
          >
            <Grid2 container rowSpacing={1.6} columnSpacing={1.1}>
              {list.map((item, j) => {
                const isSelected =
                  selected?.header === item.header &&
                  selected?.body === item.body &&
                  !selected.custom;
                const [headerFont, headerStyle] = item.header.split(",");
                const [bodyFont, bodyStyle] = item.body.split(",");
                return (
                  <Grid2
                    className="pr-1"
                    size={{ md: 6, sm: 12, xs: 6 }}
                    key={j}
                  >
                    <SelectListButton
                      selected={isSelected}
                      onClick={() => onChange(item)}
                    >
                      <ListItemText
                        className={`${
                          isSelected ? "w-[90%]" : "w-full"
                        } truncate`}
                        primary={headerFont}
                        primaryTypographyProps={{
                          sx: {
                            fontFamily: `"${headerFont}", ${headerStyle}`,
                            fontWeight: `${
                              headerFont === "Corben" ? "normal" : "bold"
                            }`,
                            color: "#1A1A1A",
                          },
                          className: "",
                        }}
                        secondaryTypographyProps={{
                          sx: {
                            fontFamily: `"${bodyFont}", ${bodyStyle}`,
                            color: "#1A1A1A",
                          },
                        }}
                        secondary={bodyFont}
                      />
                    </SelectListButton>
                  </Grid2>
                );
              })}
              {list.length < 5 ? (
                <>
                  <Grid2 size={{ md: 6, sm: 12, xs: 6 }}>
                    <Box className="w-full h-full  py-10  bg-transparent" />
                  </Grid2>
                </>
              ) : null}
            </Grid2>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

FontList.propTypes = {
  items: PropTypes.array,
  page: PropTypes.number,
  selected: PropTypes.object,
  onChange: PropTypes.func,
};
export default FontList;
